import React, { useContext } from "react";
import SideBar from "components/common/SideBar/SideBarNew";
import { LoginContext } from "helpers/LoginContext";
import { usePlatformAdmin } from "context/PlatformAdminContext";

const PlatformAdminLayout = ({ banner = null, children }) => {
  const { sideBarPadding } = useContext(LoginContext);
  const { permissionsRevision } = usePlatformAdmin();

  return (
    <div className="min-h-full">
      <div
        className="fixed inset-x-0 top-0 z-40 h-1 bg-indigo-600"
        aria-hidden="true"
      />
      <SideBar />
      <div
        className={
          sideBarPadding
            ? "flex min-h-screen flex-col pt-1 duration-300 lg:pl-[4rem]"
            : "flex min-h-screen flex-col pt-1 duration-300 lg:pl-64"
        }
      >
        {banner}
        <main className="flex-1 bg-gray-50">
          <div
            key={permissionsRevision}
            className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 sm:py-8 lg:px-8"
          >
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default PlatformAdminLayout;
